import { withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';

import { StyleGuideButtons } from 'components/StyleGuide/Buttons/StyleGuideButtons';

export const StyleGuide = () => {
  return (
    <div className="container flex flex-row justify-center px-24">
      <StyleGuideButtons />
    </div>
  );
};

export default withDatasourceCheck()(StyleGuide);
